import React, { useState } from 'react';

const SLIDES = [
  {
    id: 'portada', title: 'ComuniData', subtitle: 'Plataforma de gestión territorial inteligente',
    icon: null, bg: 'linear-gradient(135deg,#0a1628,#1D4ED8)',
    content: null,
    isPortada: true,
  },
  {
    id: 'que-es', title: '¿Qué es ComuniData?', subtitle: null,
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: [
      { icon: 'ti-map', text: 'Visualización geoespacial de incidencias urbanas en tiempo real' },
      { icon: 'ti-users', text: 'Coordinación entre instituciones del gobierno local' },
      { icon: 'ti-chart-bar', text: 'Seguimiento del estado de cada hallazgo registrado' },
      { icon: 'ti-device-mobile', text: 'Acceso desde cualquier dispositivo, en campo o escritorio' },
    ],
  },
  {
    id: 'acceso', title: 'Acceso al sistema', subtitle: null,
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: null,
    isLogin: true,
  },
  {
    id: 'coordinacion', title: 'Coordinación Nacional', subtitle: 'Vista unificada de todos los sectores',
    bg: 'linear-gradient(135deg,#0f172a,#1D4ED8)',
    chips: ['Vialidad', 'Plazas', 'Alumbrado', 'Gas', 'Agua', 'Ruido'],
    content: null,
    isCoord: true,
  },
  {
    id: 'registrar', title: 'Registrar hallazgo', subtitle: 'En 3 pasos desde el campo',
    bg: 'linear-gradient(135deg,#0f172a,#0d5c3a)',
    steps: ['Selecciona la categoría', 'Describe el hallazgo', 'Envía el reporte'],
    content: null,
  },
  {
    id: 'plano', title: 'Plano de infraestructura', subtitle: 'Inventario visual georeferenciado',
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: [
      { icon: 'ti-bulb', text: 'Luminarias y red de alumbrado' },
      { icon: 'ti-road', text: 'Vías y señalización vial' },
      { icon: 'ti-ruler', text: 'Herramienta de medición de distancias' },
      { icon: 'ti-layers', text: 'Control de capas temáticas' },
    ],
  },
  {
    id: 'territorio', title: 'Vista por territorio', subtitle: 'Cobertura y métricas parroquiales',
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: null,
    isTerritorio: true,
  },
  {
    id: 'seguimiento', title: 'Seguimiento y control', subtitle: 'Gestiona el ciclo de vida de cada reporte',
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    states: [
      { label: 'Pendiente', color: '#ca8a04' },
      { label: 'En proceso', color: '#2563eb' },
      { label: 'Resuelto', color: '#22c55e' },
    ],
  },
  {
    id: 'instituciones', title: 'Vistas institucionales', subtitle: 'Cada ministerio ve solo lo suyo',
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: null,
    isInst: true,
  },
  {
    id: 'campo', title: 'Registro de campo', subtitle: 'Vista simplificada para brigadistas',
    bg: 'linear-gradient(135deg,#0f172a,#0d4a3a)',
    content: [
      { icon: 'ti-clipboard-plus', text: 'Formulario optimizado para uso en campo' },
      { icon: 'ti-wifi-off', text: 'Funciona con conectividad limitada' },
      { icon: 'ti-location', text: 'Geolocalización automática del hallazgo' },
      { icon: 'ti-photo', text: 'Captura de evidencia fotográfica' },
    ],
  },
  {
    id: 'movil', title: 'Disponible en tu teléfono', subtitle: 'Diseño adaptado para móvil',
    bg: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
    content: null,
    isMovil: true,
  },
  {
    id: 'cierre', title: 'Comienza hoy', subtitle: 'Transforma la gestión de tu ciudad',
    bg: 'linear-gradient(135deg,#0a1628,#1D4ED8)',
    content: null,
    isCierre: true,
  },
];

export default function GuiaPage() {
  const [idx, setIdx] = useState(0);
  const slide = SLIDES[idx];
  const total = SLIDES.length;

  function prev() { setIdx(i => Math.max(0, i - 1)); }
  function next() { setIdx(i => Math.min(total - 1, i + 1)); }

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#0a1628', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Manrope, sans-serif' }}
      onKeyDown={e => { if (e.key === 'ArrowRight') next(); if (e.key === 'ArrowLeft') prev(); }}
      tabIndex={0}>

      {/* Slide */}
      <div style={{ width: '100%', maxWidth: 760, maxHeight: '90vh', aspectRatio: '16/9', background: slide.bg, borderRadius: 24, overflow: 'hidden', position: 'relative', boxShadow: '0 32px 80px rgba(0,0,0,0.6)', animation: 'fadeSection 300ms ease-out' }} key={idx}>

        {/* Decorative rings */}
        <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', opacity: 0.3 }}>
          {[200,320,440].map(s => (
            <div key={s} style={{ position: 'absolute', width: s, height: s, borderRadius: '50%', border: '1px solid rgba(96,165,250,0.3)', top: '50%', right: '-10%', transform: 'translateY(-50%)', animation: `ringSpin ${20 + s / 20}s linear infinite` }} />
          ))}
        </div>

        <div style={{ position: 'relative', zIndex: 2, padding: 48, height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

          {/* Portada */}
          {slide.isPortada && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 72, height: 72, borderRadius: 22, background: 'rgba(96,165,250,0.15)', marginBottom: 20 }}>
                <svg width="36" height="36" viewBox="0 0 64 64" fill="none"><circle cx="32" cy="32" r="27" stroke="#60A5FA" strokeWidth="3"/><circle cx="24" cy="24" r="4" fill="#60A5FA"/></svg>
              </div>
              <h1 style={{ fontSize: 48, fontWeight: 800, color: '#fff', margin: '0 0 12px', letterSpacing: '-0.03em' }}>{slide.title}</h1>
              <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.55)', margin: 0 }}>{slide.subtitle}</p>
              <div style={{ marginTop: 32, display: 'inline-block', padding: '10px 24px', borderRadius: 20, background: 'rgba(96,165,250,0.15)', border: '1px solid rgba(96,165,250,0.3)', fontSize: 12, color: 'rgba(96,165,250,0.8)', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Guía de uso</div>
            </div>
          )}

          {/* Generic bullet slide */}
          {!slide.isPortada && !slide.isCierre && !slide.isLogin && !slide.isCoord && !slide.isTerritorio && !slide.isInst && !slide.isMovil && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 8px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              {slide.subtitle && <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', margin: '0 0 32px' }}>{slide.subtitle}</p>}

              {slide.content && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {slide.content.map((item, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div style={{ width: 40, height: 40, borderRadius: 12, background: 'rgba(96,165,250,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className={`ti ${item.icon}`} style={{ fontSize: 18, color: '#60A5FA' }} />
                      </div>
                      <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', lineHeight: 1.4 }}>{item.text}</span>
                    </div>
                  ))}
                </div>
              )}

              {slide.steps && (
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  {slide.steps.map((s, i) => (
                    <div key={i} style={{ flex: 1, background: 'rgba(255,255,255,0.07)', borderRadius: 16, padding: 20, textAlign: 'center' }}>
                      <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#22c55e22', border: '1px solid #22c55e55', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: 16, fontWeight: 800, color: '#22c55e' }}>{i + 1}</div>
                      <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', margin: 0 }}>{s}</p>
                    </div>
                  ))}
                </div>
              )}

              {slide.states && (
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  {slide.states.map((st) => (
                    <div key={st.label} style={{ flex: 1, background: `${st.color}22`, border: `1px solid ${st.color}44`, borderRadius: 16, padding: '20px', textAlign: 'center' }}>
                      <div style={{ fontSize: 20, fontWeight: 800, color: st.color, marginBottom: 6 }}>●</div>
                      <p style={{ fontSize: 14, fontWeight: 700, color: st.color, margin: 0 }}>{st.label}</p>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* Login slide */}
          {slide.isLogin && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 28px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              <div style={{ background: 'rgba(255,255,255,0.07)', borderRadius: 18, padding: 24, maxWidth: 320 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)', marginBottom: 6, letterSpacing: '0.08em' }}>CORREO ELECTRÓNICO</div>
                <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>admin@comunidata.com</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)', marginBottom: 6, letterSpacing: '0.08em' }}>CONTRASEÑA</div>
                <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px', marginBottom: 18, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>••••••••</div>
                <div style={{ padding: '12px', borderRadius: 12, background: 'linear-gradient(135deg,#1D4ED8,#2563EB)', textAlign: 'center', fontSize: 13, fontWeight: 700, color: '#fff' }}>Ingresar</div>
              </div>
            </>
          )}

          {/* Coordinación chips */}
          {slide.isCoord && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 8px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', margin: '0 0 28px' }}>{slide.subtitle}</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {slide.chips?.map(c => (
                  <div key={c} style={{ padding: '8px 16px', borderRadius: 20, background: 'rgba(96,165,250,0.15)', border: '1px solid rgba(96,165,250,0.3)', fontSize: 13, fontWeight: 700, color: '#60A5FA' }}>{c}</div>
                ))}
              </div>
            </>
          )}

          {/* Territorio */}
          {slide.isTerritorio && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 28px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                {['El Paraíso · 85%', 'Las Mercedes · 72%', 'La Florida · 90%', 'La Vega · 61%'].map(p => (
                  <div key={p} style={{ background: 'rgba(255,255,255,0.07)', borderRadius: 14, padding: '14px 16px' }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>{p.split('·')[0].trim()}</div>
                    <div style={{ marginTop: 8, height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2 }}>
                      <div style={{ height: '100%', width: p.split('·')[1].trim(), background: 'linear-gradient(90deg,#60A5FA,#1D4ED8)', borderRadius: 2 }} />
                    </div>
                    <div style={{ fontSize: 10, color: '#60A5FA', fontWeight: 700, marginTop: 4 }}>{p.split('·')[1].trim()} cobertura</div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Instituciones */}
          {slide.isInst && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 28px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {[
                  { nombre: 'Vialidad', color: '#dc2626', icon: 'ti-road' },
                  { nombre: 'Deporte', color: '#22c55e', icon: 'ti-trees' },
                  { nombre: 'Alumbrado', color: '#ca8a04', icon: 'ti-bulb' },
                  { nombre: 'Brigadista', color: '#0d9488', icon: 'ti-clipboard-plus' },
                ].map(i => (
                  <div key={i.nombre} style={{ padding: '12px 16px', borderRadius: 16, background: `${i.color}22`, border: `1px solid ${i.color}44`, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <i className={`ti ${i.icon}`} style={{ color: i.color, fontSize: 16 }} />
                    <span style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>{i.nombre}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Móvil */}
          {slide.isMovil && (
            <>
              <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 8px', letterSpacing: '-0.02em' }}>{slide.title}</h2>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', margin: '0 0 28px' }}>{slide.subtitle}</p>
              <div style={{ display: 'flex', gap: 12 }}>
                {['📱 iOS', '🤖 Android', '💻 Web'].map(d => (
                  <div key={d} style={{ flex: 1, background: 'rgba(255,255,255,0.07)', borderRadius: 14, padding: '18px', textAlign: 'center', fontSize: 14, color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>{d}</div>
                ))}
              </div>
            </>
          )}

          {/* Cierre */}
          {slide.isCierre && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 52, marginBottom: 16 }}>🌐</div>
              <h2 style={{ fontSize: 40, fontWeight: 800, color: '#fff', margin: '0 0 12px', letterSpacing: '-0.03em' }}>{slide.title}</h2>
              <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.55)', margin: '0 0 28px' }}>{slide.subtitle}</p>
              <a href="/login" style={{ display: 'inline-block', padding: '13px 32px', borderRadius: 16, background: 'linear-gradient(135deg,#1D4ED8,#60A5FA)', color: '#fff', fontWeight: 700, fontSize: 14, textDecoration: 'none', boxShadow: '0 8px 24px rgba(29,78,216,0.4)' }}>
                Ir a ComuniData →
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div style={{ position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', gap: 16, zIndex: 20 }}>
        <button onClick={prev} disabled={idx === 0} style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: idx === 0 ? 0.3 : 1 }}>
          <i className="ti ti-chevron-left" />
        </button>
        <div style={{ display: 'flex', gap: 5 }}>
          {SLIDES.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)}
              style={{ width: i === idx ? 20 : 6, height: 6, borderRadius: 3, background: i === idx ? '#60A5FA' : 'rgba(255,255,255,0.25)', transition: 'all 300ms' }} />
          ))}
        </div>
        <button onClick={next} disabled={idx === total - 1} style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: idx === total - 1 ? 0.3 : 1 }}>
          <i className="ti ti-chevron-right" />
        </button>
      </div>

      {/* Slide counter */}
      <div style={{ position: 'fixed', top: 20, right: 20, fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600 }}>
        {idx + 1} / {total}
      </div>
    </div>
  );
}
